import { render, staticRenderFns } from "./LunchRegistrationHistory.vue?vue&type=template&id=799d5a80&scoped=true"
import script from "./LunchRegistrationHistory.vue?vue&type=script&lang=js"
export * from "./LunchRegistrationHistory.vue?vue&type=script&lang=js"
import style0 from "./LunchRegistrationHistory.vue?vue&type=style&index=0&id=799d5a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d5a80",
  null
  
)

export default component.exports